import React, { useState, useEffect } from "react";
import Card from "../../Components/Card/card";
import Navbar from "../../Components/Navbar/navbar";
import Topbar from "../../Components/Topbar/Topbar";
import "./dashboard.css";
import Calendar from "moedim";
// import Performance from "../Performance/performance";
import Piechart from "../Piechart/Piechart";
import Performancecard from "../../Components/Card/Performancecard/Performancecard";
import EventList from "../events/eventsList";

const Dashboard = ({
  urole,
  createnotice,
  forwardnotice,
  page,
  tab,
  empselect,
}) => {
  const [value, setValue] = useState(new Date());

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleNotice = () => {
    createnotice();
  };

  const handleAppraisalStatus = () => {
    tab("treatedapp");
  };

  const handleForward = () => {
    forwardnotice();
  };

  const handleUpcomingEvents = () => {
    tab("events");
  };

  return (
    <div className="dashboard-main-container">
      {urole.role === "HR" ? (
        <Navbar tabtext={`Hello ${urole.role}!`} currentab={page} />
      ) : (
        <Navbar tabtext={`Hello ${urole.lname}!`} currentab={page} />
      )}
      <Topbar
        role={urole}
        createnotice={handleNotice}
        forwardnotice={handleForward}
      />
      <div className="mid-bar-container">
        <div className="subb-mid-bar-container">
          {urole.role === "STAFF" ? (
            <Card text1="13 days" text2="Appraisal Countdown" icon="3" />
          ) : (
            <Card
              text1={empselect !== undefined ? empselect.allStaffs.length : ""}
              text2="Staff"
              icon="1"
            />
          )}
        </div>

        <div className="su-mid-bar-container">
          <Calendar
            className="calendar-hrs"
            value={value}
            onChange={(d) => setValue(d)}
          />
        </div>

        <div className="sub-mid-bar-container" onClick={handleUpcomingEvents}>
          <Card text1={EventList.length} text2="Events" icon="2" />
        </div>
      </div>

      <div
        className={
          urole.role === "STAFF"
            ? "mid-bar-container-twn"
            : "mid-bar-container-tw"
        }
      >
        <div className="mid-bar-left">
          <Performancecard />
        </div>
        {urole.role !== "STAFF" && (
          <div className="mid-bar-right" onClick={handleAppraisalStatus}>
            <Piechart />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
